import script from "./SignUpBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./SignUpBanner.vue?vue&type=script&setup=true&lang=js"

import "./SignUpBanner.vue?vue&type=style&index=0&id=e7d5a602&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e7d5a602"]])

export default __exports__